import type {TextSize} from '@Components/text';

export enum SuggestionPillType {
  NEUTRAL = 1,
  SECONDARY = 2,
}

export interface SuggestionPillProps {
  id: string;
  text: string;
  onClick: (text: string, id: string) => void;
  type?: SuggestionPillType;
  className?: string;
  isSelected?: boolean;
  hasRightIcon?: string;
  rightIconClassName?: string;
  textClassName?: string;
  isTextBold?: boolean;
  hasLeftIcon?: string;
  leftIconClassName?: string;
  textSize?: TextSize;
  hasHover?: boolean;
}